import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { dveDesetinneMistaRegExp } from 'enums/regExp';

export const dveDesetinneMistaValidation = (zeroNotAllowed?: boolean) => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (
                (!value || dveDesetinneMistaRegExp.test(value)) && zeroNotAllowed
                    ? value === '' || (Number(value) !== 0 && value !== '0')
                    : true
            )
                return Promise.resolve();
            return Promise.reject(
                <TranslateText>
                    {Number(value) === 0 || value === '0'
                        ? 'NEVALIDNI_PROCENTA_100_06_0'
                        : 'NEVALIDNI_CISLO_DESETINNE_2'}
                </TranslateText>
            );
        }
    })
];

export default dveDesetinneMistaValidation;
